import { fullName, initials } from "@/lib/api";
import { MapPin, Building2 } from "lucide-react";

export const StaffCard = ({ staff, onSelect }) => {
  return (
    <div
      data-testid={`staff-card-${staff.id}`}
      onClick={() => onSelect(staff)}
      className="border-r border-b border-[#0A1F44]/20 p-6 hover:bg-[#E6EAF1] transition-colors duration-200 cursor-pointer flex flex-col group"
    >
      <div className="w-16 h-16 mb-4 overflow-hidden bg-[#0A1F44]/5 flex items-center justify-center">
        {staff.avatar_url ? (
          <img
            src={staff.avatar_url}
            alt={fullName(staff)}
            className="w-16 h-16 object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
          />
        ) : (
          <span className="font-serif text-2xl text-[#0A1F44]/70">{initials(staff)}</span>
        )}
      </div>
      <h3 className="font-serif text-xl text-[#0A1F44] leading-tight">{fullName(staff)}</h3>
      <div className="text-[11px] uppercase tracking-[0.15em] text-[#C0982E] mt-2 font-medium">
        {staff.department || "—"}{staff.department2 && staff.department2.trim().toLowerCase() !== (staff.department || "").trim().toLowerCase() ? ` / ${staff.department2}` : ""}
      </div>
      <div className="mt-auto pt-4 space-y-1.5 text-sm text-[#0A1F44]/60">
        {staff.school_campus && (
          <div className="flex items-center gap-1.5" data-testid="card-campus">
            <Building2 className="w-3.5 h-3.5" strokeWidth={1.5} />
            {staff.school_campus}
          </div>
        )}
        <div className="flex items-center gap-1.5">
          <MapPin className="w-3.5 h-3.5" strokeWidth={1.5} />
          Rm: {staff.room || "—"}
        </div>
      </div>
    </div>
  );
};
